import { genHtmlOptions, genMenuItems } from '../utils';
export const SENTIMENT_SCORE_OPTIONS = [
    { id: 1, value: "1" },
    { id: 2, value: "2" },
    { id: 3, value: "3" },
    { id: 4, value: "4" },
    { id: 5, value: "5" },
    { id: 6, value: "6" },
    { id: 7, value: "7" },
    { id: 8, value: "8" },
    { id: 9, value: "9" },
    { id: 10, value: "10" },
];
export const ConfirmationDialogText = {
    delete_template: { title: 'Please confirm', body: 'Do you really want to delete this notification template?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    delete_templates: { title: 'Please confirm', body: 'Do you really want to delete these notification templates?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    delete_review: { title: 'Please confirm', body: 'Do you really want to delete this tour review?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    delete_reviews: { title: 'Please confirm', body: 'Do you really want to delete these tour reviews?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
};

export const SUPPORT_CONTACT_TYPES = {};
export const SUPPORT_CONTACT_PHONE = 1;
export const SUPPORT_CONTACT_EMAIL = 2;
export const SUPPORT_CONTACT_CHAT = 3;
export const SUPPORT_CONTACT_SOCIAL = 4;
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_PHONE] = 'Phone';
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_EMAIL] = 'Email';
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_CHAT] = 'Chat';
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_SOCIAL] = 'Social';

// Social links (backend plan 2026-10-29-operator-social-links): the network is derived by the server from the URL.
export const SOCIAL_NETWORK_LABELS = {
    facebook: 'Facebook',
    instagram: 'Instagram',
    x: 'X',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    tripadvisor: 'Tripadvisor',
    pinterest: 'Pinterest',
    linkedin: 'LinkedIn',
    yelp: 'Yelp',
    trustpilot: 'Trustpilot',
    google: 'Google',
    other: 'Other link',
};
// Who wrote a support contact: discovery only ever updates its own rows (restech / website).
export const SUPPORT_CONTACT_SOURCE_LABELS = {
    restech: 'Found in your booking system',
    website: 'Found on your website',
};

export const SUPPORT_CONTACT_SUBTYPES = {};
export const SUPPORT_CONTACT_GENERAL = 0;
export const SUPPORT_CONTACT_SALES = 1;
export const SUPPORT_CONTACT_OPERATIONS = 2;
export const SUPPORT_CONTACT_OTHER = 3;
SUPPORT_CONTACT_SUBTYPES[SUPPORT_CONTACT_GENERAL] = 'General';
SUPPORT_CONTACT_SUBTYPES[SUPPORT_CONTACT_SALES] = 'Sales';
SUPPORT_CONTACT_SUBTYPES[SUPPORT_CONTACT_OPERATIONS] = 'Operations';
SUPPORT_CONTACT_SUBTYPES[SUPPORT_CONTACT_OTHER] = 'Other';

export const REVIEW_ASPECT_TYPES = {};
export const REVIEW_ASPECT_TYPE_RATING = 0
export const REVIEW_ASPECT_TYPE_RATING_WITH_COMMENT = 1
export const REVIEW_ASPECT_TYPE_RATING_WITH_CONDITIONAL_COMMENT = 2
export const REVIEW_ASPECT_TYPE_COMMENT = 3
REVIEW_ASPECT_TYPES[REVIEW_ASPECT_TYPE_RATING] = 'Rating';
// REVIEW_ASPECT_TYPES[REVIEW_ASPECT_TYPE_RATING_WITH_COMMENT] = 'Rating with comment';
// REVIEW_ASPECT_TYPES[REVIEW_ASPECT_TYPE_RATING_WITH_CONDITIONAL_COMMENT] = 'Rating with conditional comment';
REVIEW_ASPECT_TYPES[REVIEW_ASPECT_TYPE_COMMENT] = 'Comment';

export const REVIEW_ASPECT_COMMENT_TYPES = {};
export const REVIEW_ASPECT_COMMENT_TYPE_NEVER = 0
export const REVIEW_ASPECT_COMMENT_TYPE_LOW_RATING = 1
export const REVIEW_ASPECT_COMMENT_TYPE_HIGH_RATING = 2
export const REVIEW_ASPECT_COMMENT_TYPE_ALWAYS = 3
REVIEW_ASPECT_COMMENT_TYPES[REVIEW_ASPECT_COMMENT_TYPE_NEVER] = "Never"
REVIEW_ASPECT_COMMENT_TYPES[REVIEW_ASPECT_COMMENT_TYPE_LOW_RATING] = "Negative feedback"
REVIEW_ASPECT_COMMENT_TYPES[REVIEW_ASPECT_COMMENT_TYPE_HIGH_RATING] = "Positive feedback"
REVIEW_ASPECT_COMMENT_TYPES[REVIEW_ASPECT_COMMENT_TYPE_ALWAYS] = "Always"

export const supportContactTypesMenuItems = genMenuItems(SUPPORT_CONTACT_TYPES);
export const supportContactTypesOptions = genHtmlOptions(SUPPORT_CONTACT_TYPES);

export const supportContactSubtypesMenuItems = genMenuItems(SUPPORT_CONTACT_SUBTYPES);
export const supportContactSubtypesOptions = genHtmlOptions(SUPPORT_CONTACT_SUBTYPES);

export const reviewAspectTypesMenuItems = genMenuItems(REVIEW_ASPECT_TYPES);
export const reviewAspectTypesOptions = genHtmlOptions(REVIEW_ASPECT_TYPES);

export const reviewAspectCommentTypesMenuItems = genMenuItems(REVIEW_ASPECT_COMMENT_TYPES);
export const reviewAspectCommentTypesOptions = genHtmlOptions(REVIEW_ASPECT_COMMENT_TYPES);
